export default {
  product: null,
  showButtonBuy: false,
  recurrentPricesModalIsOpen: null,
  recurrentProduct: null,
};
